var map = {
	"./cht.json": [
		20536,
		536
	],
	"./en.json": [
		81005,
		5
	],
	"./id.json": [
		73838,
		838
	],
	"./ja.json": [
		5723,
		723
	],
	"./ko.json": [
		43355,
		355
	],
	"./tds/en.json": [
		51692,
		692
	],
	"./tds/zh_CN.json": [
		29661,
		661
	],
	"./th.json": [
		36734,
		734
	],
	"./zh_CN.json": [
		55947,
		947
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10471;
module.exports = webpackAsyncContext;